(function () {
  function initPlanoTecnico(root) {
    if (!root || root.dataset.planoTecnicoInitialized === 'true') return;

    root.dataset.planoTecnicoInitialized = 'true';

    var modal = root.querySelector('[data-plano-modal]');
    var modalMedia = root.querySelector('[data-plano-modal-media]');
    var openButtons = Array.prototype.slice.call(root.querySelectorAll('[data-plano-open]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-plano-close]'));

    function moveModalToBody() {
      if (!modal) return;

      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    }

    function openModal() {
      if (!modal) return;

      moveModalToBody();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('plano-tecnico-modal-open');
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('plano-tecnico-modal-open');
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (!modal.classList.contains('is-open')) return;

        var clickedClose = event.target.closest('[data-plano-close]');
        var clickedInsideImage = modalMedia && modalMedia.contains(event.target);

        if (clickedClose || !clickedInsideImage) {
          closeModal();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function initAllPlanoTecnico() {
    var roots = document.querySelectorAll('[data-plano-root]');

    roots.forEach(function (root) {
      initPlanoTecnico(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPlanoTecnico);
  } else {
    initAllPlanoTecnico();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-plano-root]');

    if (root) {
      root.dataset.planoTecnicoInitialized = 'false';
      initPlanoTecnico(root);
    }
  });
})();